/*!

=========================================================
* Argon Dashboard React - v1.2.3
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import { Link } from "react-router-dom";
// reactstrap components
import {
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Form,
  FormGroup,
  InputGroupAddon,
  InputGroupText,
  Input,
  InputGroup,
  Navbar,
  Nav,
  Container,
  Media,
  Row,
  Col
} from "reactstrap";
import albany_logo from "../../assets/images/ualbany.png"
import ul_logo from "../../assets/images/ulsolutions_logo_horz_wht_rgb.png"
import wind_logo from "../../assets/images/wind.png"
import wind_logo2 from "../../assets/images/wind_2.png"

const AdminNavbar = (props) => {
  return (
    <>
      {/* <Navbar className="bg-gradient-default" id="navbar-main" > */}
      <Container fluid className="bg-gradient-default" >
        <Row className="d-flex justify-content-end" >
          <Col >
            <Link
              style={{ fontSize: '50px', fontStyle: 'italic', color: 'white', fontWeight: 500 }}
              // className="h1 mb-0 text-white text-uppercase d-none d-lg-inline-block"
              to="/"
            >
              {/* <i className="fa-solid fa-fan fa-spin"></i>*/}
              <img src={wind_logo2} style={{ height: '10vh', paddingBottom: 10 }} />
              {props.brandText}

            </Link>
          </Col>
          <Col className="d-flex justify-content-end" style={{ alignItems: 'flex-end'}} >
            <img src={albany_logo} style={{ height: '10vh', padding: 10 }} />
            <img src={ul_logo} style={{ height: '10vh', padding: 10 }} />
          </Col>
        </Row>

        <Row className="d-flex justify-content-between" >

          <Col className="d-flex justify-content-start" >
            <Link
              style={{ fontSize: 20, fontStyle: 'italic' }}
              className="h1 mb-2 text-white text-uppercase d-none d-lg-inline-block"
              to="/"
            >
              Virtual Offshore Wind Energy Laboratory & Simulator
            </Link>
          </Col>

          <Col className="d-flex justify-content-end" style={{ alignItems: 'center' }} sm={2} md={2} lg={2} xl={2}>

            {/* <Form className="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
            <FormGroup className="mb-0">
              <InputGroup className="input-group-alternative">
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <i className="fas fa-search" />
                  </InputGroupText>
                </InputGroupAddon>
                <Input placeholder="Search" type="text" />
              </InputGroup>
            </FormGroup>
          </Form> */}

            {/* <Nav className="align-items-center d-none d-md-flex" navbar> */}
            <UncontrolledDropdown nav>
              <DropdownToggle className="pr-0" nav>
                <Media className="align-items-center">
                  <span className="avatar avatar-sm rounded-circle" >
                  <i className="ni ni-bullet-list-67" />
                    {/* <img
                      alt="..."
                      src={require("../../assets/img/theme/team-4-800x800.jpg")}
                    /> */}
                  </span>
                  <Media className="ml-2 d-none d-lg-block">
                    <span className="mb-0 text-sm font-weight-bold" style={{color:'white'}}>
                      Menu
                    </span>
                  </Media>
                </Media>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" right>
                {/* <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Welcome!</h6>
                </DropdownItem> */}
                <DropdownItem to="/admin/index" tag={Link}>
                  <i className="ni ni-tv-2" />
                  <span>Dashboard</span>
                </DropdownItem>
                <DropdownItem to="/admin/about" tag={Link}>
                  <i className="ni ni-single-copy-04" />
                  <span>About</span>
                </DropdownItem>
                {/* <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-calendar-grid-58" />
                  <span>Activity</span>
                </DropdownItem>
                <DropdownItem to="/admin/user-profile" tag={Link}>
                  <i className="ni ni-support-16" />
                  <span>Support</span>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem href="#pablo" onClick={(e) => e.preventDefault()}>
                  <i className="ni ni-user-run" />
                  <span>Logout</span>
                </DropdownItem> */}
              </DropdownMenu>
            </UncontrolledDropdown>
            {/* </Nav> */}
          </Col>
        </Row>
      </Container>
      {/* </Navbar> */}
    </>
  );
};

export default AdminNavbar;
